import React from "react";
import { Button, Stack, Link, Box } from "@mui/material";
import { useTranslations } from "next-intl";
import { CustomTypographyComponent } from "@patron/ui/text";
import { LoginForm, LoginFormState } from "../../../forms/LoginForm";
import { useTheme } from "@patron/utils/theme";
import axios from "axios";

export const LoginComposite = () => {
  const t = useTranslations();
  const loginRef = React.useRef(null);
  const theme = useTheme();
  const [failedLogin, setFailedLogin] = React.useState<boolean>(false);

  const handleLoginDetails = (val: LoginFormState) => {
    if (val) {
      axios
        .post(
          "/auth/login",
          { username: val.userName, password: val.password },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          },
        )
        .then((res: any) => {
          if (res && res.data && res.data.Status === 200) {
            setFailedLogin(false);
            window.location.href = "/";
          } else {
            setFailedLogin(true);
          }
        })
        .catch((FEerror: any) => {
          console.log("FE error", FEerror);
          setFailedLogin(true);
        });
    }
  };

  const handleLoginClicked = () => {
    if (loginRef && loginRef.current) {
      //@ts-ignore
      loginRef.current.onSubmit();
    }
  };

  return (
    <Stack alignItems="center" height="500px" width="500px" id="LoginComposite">
      <Stack mt={3} height={"20%"} mb={6}>
        <Box
          component="img"
          sx={{
            height: 100,
          }}
          //@ts-ignore
          alt="Novus logo"
          src="https://storage.googleapis.com/novus-static/Novus-highres.png"
        />
      </Stack>
      <Stack mt={2} spacing={2} justifyContent={"center"} alignItems="center" width="100%">
        <CustomTypographyComponent variant="h5">{t("login.loginNovus")}</CustomTypographyComponent>
        <CustomTypographyComponent>{t("common.fillDetails")}</CustomTypographyComponent>
      </Stack>
      {failedLogin && (
        <CustomTypographyComponent variant="body1" data-cy="failedLoginText" color={theme.appColors.error}>
          {t("login.invalidCredentials")}
        </CustomTypographyComponent>
      )}
      <Stack justifyContent={"center"} alignItems="center" width="100%">
        <LoginForm onLoginDetails={handleLoginDetails} ref={loginRef} />
      </Stack>

      <Stack>
        <Stack alignItems={"center"} width="100%">
          <Button
            data-cy="loginButton"
            color="primary"
            variant="contained"
            onClick={handleLoginClicked}
            sx={{ mr: 1, width: "60%" }}
          >
            {t("login.login")}
          </Button>
        </Stack>
      </Stack>
      <Stack mt={4}>
        <Link href="/forgotpassword">
          <CustomTypographyComponent color={theme.palette.primary.main}>{t("login.forgotPassword")}</CustomTypographyComponent>
        </Link>
      </Stack>
    </Stack>
  );
};

export default LoginComposite;
